/* eslint-disable */
<template>
  <!-- About Content -->
    <div class="about-all">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <div class="about-pic mt-5">
              <img src="../assets/img/tp3.jpg" class="img-fluid">
            </div>
            <div class="about-pic mt-5">
              <img src="../assets/img/bag5.jpg" class="img-fluid">
            </div>
          </div>
          <div class="col-md-6">
            <div class="container">
              <div class="about-content mt-5">
                <p><span class="orange">MB</span> Clothing Started with a simple visit to the Mall. Mr Adebayo was walking through over average local mall, and was exhausted after browsing through endless stores that all had the same premise - overpriced clothing that lacked style and the items were the same month after months. Mr Adebayo walked out of the final store and told the sales man, "This is ridiculous, I should Open my own clothing store. I will Offer new style every week, make it affortable and on trend." </p>
                <p>That Idea led to the concept of the first <span class="orange">MB</span> Clothing Store Around Yaba, Lagos in March 2014, Just eight weeks after that trip to the mall.</p>
                <p>Over the years, <span class="orange">MB</span> Clothing's heart has never changed- to keep changing the world, one dress at a time. Our goal is to make every experience just that; an experience, not just "shopping". Whether that's online or in store, we hope you enjoy "MB Clothing" while shopping with us.</p>
                <p>At the core of the company, <span class="orange">MB</span> Clothing has one main mission - to show the love of the christ and help customers realise their worth. Our brand strives to make sure that each customer walking through the doors leaves feeling More confident and loved than they walked In.</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="about-pic mt-5">
              <img src="../assets/img/tp2.jpg" class="img-fluid">
            </div>
            <div class="about-pic mt-5">
              <img src="../assets/img/tshirt1.jpg" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "AboutSection"
};
</script>

<style></style>
